/* eslint-disable no-nested-ternary */
import { Avatar, Button, Grid, Menu, MenuItem, TextField, Tooltip, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddBoxRounded } from '@material-ui/icons';
import _sortBy from 'lodash/sortBy';
import CloseIcon from '@material-ui/icons/Close';
import FileIcon from '../../assets/FileIcon';
import Filter from '../../assets/FilterIcon';
import AssignJourneyDept from './AssignJourneyDept';
import service from '../../apis/service';
import ChangeOrderJourney from '../journey/ChangeOrderJourneys';
import EditIcon from '../../assets/SvgIonReorderTwo';
import {
  getAssignedJourneys,
  getJourneyList,
  getMandatoryJourneys,
  showProgress,
} from '../../redux/actions/DealershipActions';
import ZeroState from '../common/ZeroState';
import JourneyCardItem from './JourneyCardItem';
import { ErrorToast, formateDate, journeyFilter, searchArray } from '../utils/Utils';
import Modal from '../common/Modal';
import { apiEndpoints } from '../../constants/apiEndpoints';
import GetJourneys from '../../apis/GetJourneys';

const assignFilterLabels = [
  'All',
  'Mandatory',
  'Custom Assigned',
  'Manager Assigned',
  'Plan Assigned',
  'Dealership Assigned',
];

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
    padding: '6px 16px 6px 16px',
  },
  searchText: {
    width: '50vh',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '170px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  journeyThumbnail: {
    height: '60px',
    width: '48px',
    borderRadius: '4px',
  },
  bottom: {
    marginBottom: '-10px',
  },
  secondaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '134%',
    width: '170px',
    color: '#667085',
  },
  journeyFromText: {
    textTransform: 'capitalize',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#667085',
    width: '43px',
    height: '14px',
  },
  journeyFromBox: {
    marginLeft: '5px',
    marginRight: '5px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 8px',
    background: '#F2F4F7',
    borderRadius: '4px',
    width: '32px',
    height: '25px',
  },
  mandatoryBox: {
    marginLeft: '5px',
    marginRight: '5px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 8px',
    background: '#F2F4F7',
    borderRadius: '4px',
    width: '82px',
    height: '25px',
  },
  mandatoryText: {
    textTransform: 'capitalize',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#667085',
    width: '43px',
    height: '14px',
  },
  journeyAddIcon: {
    height: '42px',
    width: '42px',
    color: '#622FEE',
    marginLeft: '5px',
    cursor: 'pointer',
  },
  featherPlus: {
    width: '30px',
    height: '42px',
    background: '#F2F4F7',
    cursor: 'pointer',
    borderRadius: '8px',
    marginLeft: '10px',
  },
  tableCol: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'center',
    fontSize: '14px',
    minWidth: '100px',
  },
  tableColAssignee: {
    border: '1px solid #ddd',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  tableHeading: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'center',
    minWidth: '100px',
  },
  modalHeading: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    zIndex: '99',
    background: 'white',
    width: '450px',
  },
}));

export default function JourneyCardV2({ flow = 'rule', showJourneyAddIcon = false }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const journeys = useSelector((state) => state.getAssignedJourneys.assignedJourneys);
  const dealershipPlans = useSelector((state) => state.DealershipDetails.dealershipdetails).plans;
  const departmentRoleID = useSelector((state) => state.getSelectedRoleID);
  const departmentID = useSelector((state) => state.getDepartment);

  const [searchJVal, setSearchJVal] = useState('');
  const [filterJArray, setFilterJArray] = useState([]);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [assignFilter, setAssignFilter] = useState('All');
  const [showAddJourneyPopup, setShowAddJourneyPopup] = useState(false);
  const [planJourneys, setPlanJourneys] = useState([]);
  const [showJourneyReorderPopup, setShowJourneyReorderPopup] = useState(false);
  const dealershipID = useSelector((state) => state.getDealershipID);
  const [isOpenMA, setIsOpenMA] = useState(false);
  const [assignees, setAssignees] = useState([]);

  useEffect(() => {
    setSearchJVal('');
    setFilterJArray(journeys || []);
    setAssignFilter('All');
  }, [journeys]);

  const handleSearchJourneys = (e) => {
    const input = e.target.value;
    setSearchJVal(input);
    const filteredIArray = searchArray(journeys, ['title'], input);
    handleAssignFilter(filteredIArray);
  };

  const handleAssignFilter = (journey) => {
    const result = journeyFilter(journey, assignFilter);
    setFilterJArray(result);
  };

  useEffect(() => {
    setSearchJVal('');
    handleAssignFilter(journeys);
  }, [assignFilter]);

  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
  };
  useEffect(() => {
    const fetchJourneys = async () => {
      try {
        const dataJourney = await GetJourneys();
        dispatch(getJourneyList('fetch', dataJourney));
      } catch (error) {
        ErrorToast(error);
      }
    };

    fetchJourneys();
  }, [dispatch]);

  useEffect(() => {
    if (!dealershipPlans) return;

    const fetchAllJourneys = async () => {
      const tempArr = [];
      const uniqueIds = new Set();

      await Promise.all(
        dealershipPlans.map(async (item) => {
          try {
            const response = await service.get(apiEndpoints.DEALER_JOURNEY_PLAN.replace('ID', item.id));
            response.forEach((journey) => {
              if (!uniqueIds.has(journey.id)) {
                uniqueIds.add(journey.id);
                tempArr.push(journey);
              }
            });
          } catch (error) {
            console.log(error);
          }
        }),
      );

      setPlanJourneys(tempArr);
    };

    setPlanJourneys([]);
    fetchAllJourneys();
  }, [dealershipPlans]);

  const handleShowJourneyReorder = () => {
    setShowJourneyReorderPopup(true);
  };

  const handleHideJourneyReorder = () => {
    setShowJourneyReorderPopup(false);
  };

  const handleChangeJourneyReorder = async (data = []) => {
    await service.post(apiEndpoints.DEALER_REORDER_JOURNEY, {
      dealershipId: dealershipID,
      departmentRoleId: departmentRoleID,
      sequence: data.map(({ id }) => id),
    });
    await fetchJourney('Dealership Assigned');
  };

  const fetchJourney = async (filter = 'All') => {
    setAssignFilter(filter);
    dispatch(showProgress(true));
    await service
      .get(
        apiEndpoints.DEALER_DEP_JOURNEYS.replace('DEALER_ID', dealershipID)
          .replace('DEP_ID', departmentID)
          .replace('ROLE_ID', departmentRoleID),
      )
      .then((response) => {
        const mandJourneys = [];
        dispatch(getAssignedJourneys(response));
        response?.forEach((data1) => {
          if (data1.mandatory === true) {
            mandJourneys.push(data1.id);
          }
        });
        dispatch(getMandatoryJourneys('add', mandJourneys));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const journeyFromText = (item = '', journeyData = {}) => {
    const word = `${item.split(' ')[0][0]}${item.split(' ')[1][0]}`;

    if (word === 'DA' && departmentRoleID !== 0) {
      return (
        <Tooltip
          title={
            <Grid container direction="column" style={{ padding: '10px' }}>
              <Grid item>
                <Typography noWrap variant="subtitle2" component="div">
                  Start date: {journeyData.startDate}
                </Typography>
              </Grid>
              <Grid item>
                <Typography noWrap variant="subtitle2" component="div">
                  End date: {journeyData.endDate}
                </Typography>
              </Grid>
            </Grid>
          }
        >
          <span className={classes.journeyFromText}>{word}</span>
        </Tooltip>
      );
    }
    if (word === 'MA') {
      return (
        <Tooltip title={item}>
          {/* eslint-disable-next-line  */}
          <span
            className={classes.journeyFromText}
            onClick={() => {
              setAssignees(journeyData.assignees || []);
              setIsOpenMA(true);
            }}
          >
            {word}
          </span>
        </Tooltip>
      );
    }
    return (
      <Tooltip title={item}>
        <span className={classes.journeyFromText}>{word}</span>
      </Tooltip>
    );
  };

  return (
    <Grid container direction="column">
      <Grid xs={12} item style={{ margin: '10px 0' }}>
        <Grid container>
          <Grid item style={{ marginLeft: '10px' }}>
            <TextField
              id="searchId"
              name="search"
              required
              autoComplete="off"
              autoSave="off"
              onChange={handleSearchJourneys}
              placeholder="Search Journeys"
              value={searchJVal}
              InputProps={{
                disableUnderline: true,
                className: classes.searchText,
              }}
              rows={1}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              focusRipple={false}
              disableElevation
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClickFilter}
              className={classes.featherPlus}
            >
              <Filter style={{ backgroud: '#D3D3D3', marginLeft: '0px' }} />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorElFilter}
              keepMounted
              open={Boolean(anchorElFilter)}
              onClose={handleCloseFilter}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              style={{
                marginTop: '5.5vh',
              }}
            >
              {assignFilterLabels.map((item) => (
                <MenuItem
                  key={item}
                  className={classes.menuItemStyle}
                  onClick={() => {
                    setAssignFilter(item);
                    handleCloseFilter();
                  }}
                  selected={assignFilter === item}
                >
                  {item}
                </MenuItem>
              ))}
            </Menu>
          </Grid>

          {assignFilter === 'Dealership Assigned' && departmentRoleID !== 0 && filterJArray?.length ? (
            <>
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleShowJourneyReorder}
                  className={classes.featherPlus}
                >
                  <EditIcon style={{ backgroud: '#D3D3D3', marginLeft: '0px' }} />
                </Button>
              </Grid>
              <ChangeOrderJourney
                title="Change the dealer assigned journey order"
                data={_sortBy(filterJArray, ['sequence', 'rowId'])}
                open={showJourneyReorderPopup}
                handleClose={handleHideJourneyReorder}
                handleChange={handleChangeJourneyReorder}
              />
            </>
          ) : null}

          {showJourneyAddIcon ? (
            <Grid item>
              <AddBoxRounded className={classes.journeyAddIcon} onClick={() => setShowAddJourneyPopup(true)} />
            </Grid>
          ) : null}
        </Grid>
      </Grid>
      <Grid xs={12} item>
        <Grid container style={{ marginLeft: '5px' }}>
          {journeys?.length ? (
            filterJArray.length ? (
              filterJArray.map((journey) => (
                <Grid item xs={5} style={{ margin: '10px' }} key={journey.id}>
                  <JourneyCardItem journey={journey} journeyFromText={journeyFromText} classes={classes} />
                </Grid>
              ))
            ) : (
              'No journeys found'
            )
          ) : (
            <ZeroState Icon={FileIcon} text={`No journeys have been added in this ${flow} yet.`} cardWidth="33vw" />
          )}
        </Grid>
      </Grid>
      {showAddJourneyPopup && (
        <AssignJourneyDept open close={() => setShowAddJourneyPopup(false)} add jList={planJourneys || null} />
      )}
      {isOpenMA && assignees.length ? (
        <Modal isOpen={isOpenMA} height={`${Math.min(assignees.length * 45 + 80, 550)}px`} width="450px">
          <Grid
            style={{
              maxHeight: '550px',
              overflowY: 'auto',
              width: '450px',
              overflowX: 'auto',
            }}
          >
            <Grid className={classes.modalHeading}>
              <Typography style={{ fontSize: '16px', fontWeight: '700' }}>Manager Assigned List</Typography>
              <CloseIcon onClick={() => setIsOpenMA(false)} style={{ cursor: 'pointer' }} />
            </Grid>
            <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '30px' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #ddd' }}>
                  <th className={classes.tableHeading}>Assignees</th>
                  <th className={classes.tableHeading}>Start Date</th>
                  <th className={classes.tableHeading}>End Date</th>
                </tr>
              </thead>
              <tbody>
                {assignees.map((data) => (
                  <tr key={data.fullName} style={{ borderBottom: '1px solid #ddd' }}>
                    <td className={classes.tableColAssignee}>
                      {data.profilePic ? (
                        <Avatar alt={data.fullName} src={data.profilePic} />
                      ) : (
                        <Avatar>{data.fullName[0].toUpperCase()}</Avatar>
                      )}
                      <Typography noWrap variant="caption" component="div" style={{ fontSize: '14px' }}>
                        {data.fullName}
                      </Typography>
                    </td>
                    <td className={classes.tableCol}>{formateDate(data.startDate)}</td>
                    <td className={classes.tableCol}>{formateDate(data.endDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
        </Modal>
      ) : null}
    </Grid>
  );
}
